import { render } from "./UnitForm.vue?vue&type=template&id=930139b6"
import script from "./UnitForm.vue?vue&type=script&lang=js"
export * from "./UnitForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__